'use client';

import { useState } from 'react';
import { IconButton } from '..';
import { useToggle } from '../../hooks';
import { BodyMedium } from '../../styles';
import { Info } from '@mui/icons-material';
import { RichTooltip } from './styles';

type Props = {
    icon?: React.ReactNode;
    content: string;
};

const ToolTip = ({ icon, content }: Props) => {
    const [showTooltip, toggleTooltip] = useToggle();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        toggleTooltip();
        setAnchorEl(e.currentTarget);
    };

    return (
        <div data-testid='info-tooltip'>
            <IconButton data-testid='info-button' icon={icon ?? <Info />} onClick={onClick} />
            {showTooltip ? (
                <RichTooltip
                    data-testid='menu'
                    anchorEl={anchorEl}
                    open={showTooltip}
                    onClose={() => toggleTooltip(false)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                    }}
                >
                    <BodyMedium p={2} width={312}>
                        {content}
                    </BodyMedium>
                </RichTooltip>
            ) : null}
        </div>
    );
};

export { ToolTip };
